import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SelectImpairedModule } from '@impairedShared/select-impaired/select-impaired.module';
import { FormsModule } from '@angular/forms';
import { ImpairedPaginationComponent } from './impaired-pagination/impaired-pagination.component';
import { ButtonIconModule } from '../button-icon/button-icon.module';
import { ImpairedIconModule } from '../impaired-icon/impaired-icon.module';

@NgModule({
  declarations: [ImpairedPaginationComponent],
  imports: [CommonModule, TranslateModule, ButtonIconModule, ImpairedIconModule, SelectImpairedModule, FormsModule],
  exports: [ImpairedPaginationComponent]
})
export class ImpairedPaginationModule {}
